"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.TextWrapper = exports.ContentWrapper = exports.StyledCardBody = exports.StyledImage = exports.StyledCardHeader = exports.StyledCard = exports.StyledText = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _card = require("../../../../styles/2_commonComponentStyles/card");

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _helperFunctions = require("../../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// ours
var StyledText = _styledComponents.default.div.withConfig({
  displayName: "ImageCardstyles__StyledText",
  componentId: "sc-1q5q7nl-0"
})(["text-align:left;font-family:", ";width:min-content;white-space:nowrap;"], function (props) {
  return props.theme.secondaryFont;
});

exports.StyledText = StyledText;

var StyledCard = _styledComponents.default.button.withConfig({
  displayName: "ImageCardstyles__StyledCard",
  componentId: "sc-1q5q7nl-1"
})(["", ";", ";border:none;cursor:pointer;outline:none;width:min-content;transition:ease-in-out .2s;&:not(:last-child){margin-right:", ";};&:hover{box-shadow:", ";", "{text-decoration:underline;}}"], _card.baseCard, _card.cardThemes, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return props.theme.s_card_active;
}, StyledText);

exports.StyledCard = StyledCard;

var StyledCardHeader = _styledComponents.default.div.withConfig({
  displayName: "ImageCardstyles__StyledCardHeader",
  componentId: "sc-1q5q7nl-2"
})(["", ";", ";border-bottom:none;padding:0;position:relative;"], _card.baseCardHeader, _card.cardHeaderThemes);

exports.StyledCardHeader = StyledCardHeader;

var StyledImage = _styledComponents.default.img.withConfig({
  displayName: "ImageCardstyles__StyledImage",
  componentId: "sc-1q5q7nl-3"
})(["display:block;"]);

exports.StyledImage = StyledImage;

var StyledCardBody = _styledComponents.default.div.withConfig({
  displayName: "ImageCardstyles__StyledCardBody",
  componentId: "sc-1q5q7nl-4"
})(["", ";", ";align-items:center;display:flex;justify-content:", ";min-height:5rem;padding:", ";"], _card.baseCardBody, _card.cardBodyThemes, function (props) {
  return props.textAlign;
}, function (props) {
  return props.theme.standardPadding;
});

exports.StyledCardBody = StyledCardBody;

var ContentWrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageCardstyles__ContentWrapper",
  componentId: "sc-1q5q7nl-5"
})(["font-weight:", ";display:flex;align-items:center;&,& *{color:", ";}"], function (props) {
  return props.theme.primaryMedium;
}, function (props) {
  return props.theme.c_foreground_primary;
});

exports.ContentWrapper = ContentWrapper;

var TextWrapper = _styledComponents.default.div.withConfig({
  displayName: "ImageCardstyles__TextWrapper",
  componentId: "sc-1q5q7nl-6"
})(["width:min-content;"]);

exports.TextWrapper = TextWrapper;
var StyledIcon = (0, _styledComponents.default)(_Icon.default).withConfig({
  displayName: "ImageCardstyles__StyledIcon",
  componentId: "sc-1q5q7nl-7"
})(["margin-right:", ";"], function (props) {
  return props.theme.standardPadding;
});
exports.StyledIcon = StyledIcon;